import React from 'react';

const Select_yes_no = ({ checked, onChange, tabIndex = 0, id }) => {
  const handleClick = () => {
    onChange({ target: { checked: !checked } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'y' || e.key === 'Y') {
      onChange({ target: { checked: true } });
    } else if (e.key === 'n' || e.key === 'N') {
      onChange({ target: { checked: false } });
    } else if (e.key === 'Enter') {
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <div className='bold text-h2 center'
      tabIndex={tabIndex}
      id={id}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{
        width: '25px',
        userSelect: 'none',
        textAlign: 'center',
        cursor: 'pointer', 
        padding: '4px 2px',
        borderRadius: '4px',
        backgroundColor: checked ? '#d1e7dd' : '#f8d7da', // green for yes, red for no
        color: checked ? '#06854aff' : '#ac0816ff',
      }}
    >
      {checked ? 'Yes' : 'No'}
    </div>
  );
};

export default Select_yes_no;
